import Overview from '@rebuild/materials/shared/question/Overview.vue';
import Full from '@rebuild/materials/shared/question/Full.vue';

export const componentMap = {
	overview: Overview,
	full: Full
};
